export const NodeDividerMenuActions = {
  NO_LINK: 'NO_LINK',
  PAGE_LINK: 'PAGE_LINK',
  PAGE_LINK_WITH_PARAMS: 'PAGE_LINK_WITH_PARAMS',
  URL_LINK: 'URL_LINK'
};